import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination, Autoplay } from "swiper/modules";
import "./ReviewSlider.css";

function ReviewSlider() {
  const reviews = [
    {
      text: "LushDesire is the most trusted online store for personal wellness products in India. Discreet packaging and premium quality impressed me.",
      name: "Amit Sharma",
    },
    {
      text: "I was hesitant at first, but LushDesire made the experience completely comfortable. Easy ordering, fast delivery, and excellent product quality.",
      name: "Neha Verma",
    },
    {
      text: "Best website in India for buying intimate products online. LushDesire maintains full privacy and offers genuine products.",
      name: "Rahul Mehta",
    },
    {
      text: "LushDesire understands customer privacy better than anyone. The packaging was discreet and the product quality was top-notch.",
      name: "Pooja Khanna",
    },
    {
      text: "I have ordered multiple times from LushDesire and never faced any issues. Trusted brand for sexual wellness products in India.",
      name: "Sandeep Malhotra",
    },
    {
      text: "Very informative website with a wide range of personal wellness products. LushDesire truly cares about customer comfort.",
      name: "Anjali Singh",
    },
    {
      text: "Affordable pricing and premium quality products. LushDesire is my go-to online store for intimate wellness needs.",
      name: "Vikram Joshi",
    },
    {
      text: "Excellent service, fast shipping, and complete anonymity. LushDesire sets a new standard for online sex toy shopping in India.",
      name: "Kavita Rao",
    },
  ];

  return (
    <section
      className="review-section"
      aria-label="Customer reviews for LushDesire"
    >
      {/* 🔥 MAIN SEO H1 */}
      <h1 className="title">
        LushDesire.in – Trusted Online Sex Toy Store in India | Real Customer Reviews
      </h1>

      <Swiper
        modules={[Pagination, Autoplay]}
        pagination={{ clickable: true }}
        autoplay={{ delay: 2800, disableOnInteraction: false }}
        spaceBetween={30}
        slidesPerView={1}
        breakpoints={{
          768: { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
        }}
      >
        {reviews.map((review, index) => (
          <SwiperSlide key={index}>
            <div className="review-card">
              <div className="quote-icon">❝❞</div>
              <p className="review-text">"{review.text}"</p>
              <p className="review-name">— {review.name}</p>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
}

export default ReviewSlider;
